// extracted by mini-css-extract-plugin
export default {"Link":"navbar_Link__2LCxd"};